<template>
	<h4 v-if="title && title.length > 0">
		{{title}}

		<!-- Lock/Unlock-->
		<a @click="editMode=!editMode">
			<i class="pi pi-lock" v-if="!editMode" />
			<i class="pi pi-unlock" v-if="editMode" />
		</a>
	</h4>

	<!-- Cards View-->
	<div class="col-12 flex flex-row flex-wrap" v-if="editMode">
		<template v-for="billingEntity in visibleBillingEntities" :key="billingEntity.billingEntityId">
			<div class="card mr-3 mb-3" style="width: 480px;">
				<i @click="removeEntity(billingEntity)" class="pi pi-times" style="cursor:pointer;float:right;top:-10px;position:relative;"></i>
				<div class="field">
					<label>Billing Entity Name</label>
					<InputText v-model="billingEntity.billingEntityName" @change="ensureEmptyEntity" />
				</div>
				<div class="field">
					<label>Account Number</label>
					<InputText v-model="billingEntity.accountNumber" />
				</div>
			</div>
		</template>
	</div>

	<!-- Read only indented-list view-->
	<div v-if="!editMode">
		<div class="flex flex-wrap">
			<template v-for="billingEntity in visibleBillingEntities" :key="billingEntity.billingEntityId">
				<div class="item-border-left">
					<div class="mt-2">{{billingEntity.billingEntityName}}</div>
					<div class="ml-3 mt-1 compass-red">{{billingEntity.accountNumber}}</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script lang="ts">
	import { Vue, Options } from 'vue-class-component';
	import { BillingEntityData } from '../api-client/api-client'

	@Options({
		name: 'BillingEntities',
		components: {
		},
		props: {
			title: {
				type: String,
				default: ""
			},
			billingEntities: {
				type: Array,
				default: []
			},
		},
	})
	export default class BillingEntities extends Vue {
		billingEntities: BillingEntityData[] = [];

		editMode = false;

		ensureEmptyEntity() {
			if (!this.billingEntities) {
				this.billingEntities = [];
			}

			if (!this.editMode)
				return;

			if (this.billingEntities.length == 0) {
				this.newEntity();
				return;
			}
		
			if (this.billingEntities[this.billingEntities.length - 1].billingEntityName != null) {
				this.newEntity();
			}
		}

		newEntity() {
			this.billingEntities.push(new BillingEntityData);
			return;
		}

		removeEntity(entity: BillingEntityData) {
			if (this.billingEntities.length > 0) {
				const index = this.billingEntities.indexOf(entity);
				if (index > -1) {
					if (entity.billingEntityId == null) {
						this.billingEntities.splice(index, 1);
					}
					entity.whenDeleted = new Date();
				}
			}
		}

		get visibleBillingEntities() {
			this.ensureEmptyEntity();
			return this.billingEntities.filter(c => c.whenDeleted == null);
		}
	}
</script>

<style scoped lang="scss">

	// for prime icon lock/unlock
	.pi {
		font-size: 1.5rem;
		margin-left: 10px;
		top: 1px;
		position: relative;
	}
</style>